import * as Dropdown from '@radix-ui/react-dropdown-menu';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLocales } from '@/hooks/use-locales';
import { useLocaleStore } from '@/i18n/store';
import { cn } from '@/lib/utils';

export function LocaleSwitcher() {
  const { data: locales = [], isLoading } = useLocales();
  const locale = useLocaleStore((s) => s.locale);
  const setLocale = useLocaleStore((s) => s.setLocale);

  const active = locales.find((l) => l.code === locale);

  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <Button variant="outline" size="sm" disabled={isLoading}>
          <Globe className="mr-2 h-4 w-4" />
          {active?.displayName ?? locale.toUpperCase()}
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content
          sideOffset={4}
          className="z-50 min-w-[10rem] overflow-hidden rounded-md border bg-background p-1 shadow-md"
        >
          {locales.map((l) => (
            <Dropdown.Item
              key={l.code}
              onSelect={() => setLocale(l.code)}
              className={cn(
                'relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none hover:bg-secondary',
                l.code === locale && 'font-semibold',
              )}
            >
              {l.displayName}
              <span className="ml-auto text-xs text-muted-foreground">{l.code}</span>
            </Dropdown.Item>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
}
